require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-drop-it.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-drop-it");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-drop-it!./.cache/json/javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-drop-it.json
// module id = 2427
// module chunks = 231608221292675